import React from 'react';

import { DotSeparator, Typography } from '@lyearn/ui';
import { MediaKindEnum } from '@/types/schema';

import { useMediaContext } from '../context';
import MediaSize from '../MediaSize';
import MediaType from '../MediaType';

function MediaDescription() {
  const { media } = useMediaContext();
  const isWebLink = media.kind === MediaKindEnum.WebLink;

  return isWebLink ? (
    <Typography color="text-text-secondary" variant="body-short-03">
      {media.url}
    </Typography>
  ) : (
    <DotSeparator gapX={6}>
      <MediaSize />
      <MediaType />
    </DotSeparator>
  );
}

export default React.memo(MediaDescription);
